/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const toggleDocumentUnreadPostRequestSchema = z.object({
  relative_keys: z.array(z.string()),
});
